import { useProject } from './useProject';
import {
    getDaysSinceProjectPublish,
    getPercentageFundedForProject,
    getPercentageLifecycleForProject,
} from '../project-model';
import { useSubproject } from '../../components/hooks/useSubproject';
import { useMemo } from 'react';

export const useProjectShareTrackingProperties = () => {
    const project = useProject();
    const { subproject } = useSubproject();

    const percentageFunded = getPercentageFundedForProject({ project });
    const percentageLifecycle = getPercentageLifecycleForProject({ project });
    const daysSinceStart = getDaysSinceProjectPublish({ project });
    return useMemo(
        () => ({
            'project-id': project.id,
            'subproject-id': subproject?.id,
            'percentage-funded': percentageFunded,
            'percentage-lifecycle': percentageLifecycle,
            'days-since-published': daysSinceStart,
            moneygoal: project.moneygoal,
        }),
        [project.id, subproject?.id, project.moneygoal, percentageFunded, percentageLifecycle, daysSinceStart]
    );
};
